import type { KeyboardEvent } from "react";

export const onEnter =
  (run: () => void) => (event: KeyboardEvent<HTMLElement>) => {
    if (event.key !== "Enter") {
      return;
    }
    event.preventDefault();
    run();
  };
